export enum ActionTypes {
  GALLERY_HIDE_POST = 'GALLERY_HIDE_POST',
  GALLERY_SET_FILTERS = 'GALLERY_SET_FILTERS',
  PORTFOLIO_QUERY_COMPLETE = 'PORTFOLIO_QUERY_COMPLETE',
  FETCH_GALLERY_POSTS_START = 'FETCH_GALLERY_POSTS_START',
  FETCH_GALLERY_POSTS_SUCCESS = 'FETCH_GALLERY_POSTS_SUCCESS',
  FETCH_GALLERY_POSTS_FAILURE = 'FETCH_GALLERY_POSTS_FAILURE',
  LOAD_MORE_GALLERY_POSTS_START = 'LOAD_MORE_GALLERY_POSTS_START',
  LOAD_MORE_GALLERY_POSTS_SUCCESS = 'LOAD_MORE_GALLERY_POSTS_SUCCESS',
  LOAD_MORE_GALLERY_POSTS_FAILURE = 'LOAD_MORE_GALLERY_POSTS_FAILURE',
}

export interface GallerySetFilterAction {
  type: ActionTypes.GALLERY_SET_FILTERS;
}

export interface FetchGalleryPostsStartAction {
  type: ActionTypes.FETCH_GALLERY_POSTS_START;
}

export interface FetchGalleryPostsSuccessAction {
  type: ActionTypes.FETCH_GALLERY_POSTS_SUCCESS;
}

export interface FetchGalleryPostsFailureAction {
  type: ActionTypes.FETCH_GALLERY_POSTS_FAILURE;
}

export interface LoadMoreGalleryPostsStartAction {
  type: ActionTypes.LOAD_MORE_GALLERY_POSTS_START;
}

export interface LoadMoreGalleryPostsSuccessAction {
  type: ActionTypes.LOAD_MORE_GALLERY_POSTS_SUCCESS;
}

export interface LoadMoreGalleryPostsFailureAction {
  type: ActionTypes.LOAD_MORE_GALLERY_POSTS_FAILURE;
}

export type GalleryActions =
  | GallerySetFilterAction
  | FetchGalleryPostsStartAction
  | FetchGalleryPostsSuccessAction
  | FetchGalleryPostsFailureAction
  | LoadMoreGalleryPostsStartAction
  | LoadMoreGalleryPostsSuccessAction
  | LoadMoreGalleryPostsFailureAction;
